"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileTrayMenu = void 0;
const classnames_1 = __importDefault(require("classnames"));
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../shared");
const utils_1 = require("../../utils");
const atoms_1 = require("../atoms");
const enhanced_1 = require("../enhanced");
const BackTrayItem_1 = require("./BackTrayItem");
const MobileLinks_1 = require("./MobileLinks");
const TrayItem_1 = require("./TrayItem");
const Styled = styled_components_1.default.div `
	border-bottom: 1px solid ${(p) => p.theme.palette.border};
	&:last-child {
		border-bottom: none;
	}

	.enhanced-dropdown-layout {
		flex-direction: column;

		section {
			width: 100%;
			margin: 0;
			padding: 24px;
		}

		.describe {
			padding-bottom: 0;
		}

		.main-links {
			border-right: initial;
			padding-bottom: 24px;
		}
	}
`;
const MobileTrayMenu = ({ link = {}, parentMenuOpen, trayId, locale, topOffset, }) => {
    var _a;
    const { menuOpen, setMenuOpen } = (0, shared_1.useActiveInnerMobileTray)(trayId);
    const toggleMenu = (0, shared_1.useToggleMenu)(menuOpen, setMenuOpen, "");
    const onKeyUp = (0, shared_1.useHandleKeyUp)(toggleMenu, toggleMenu);
    const isEnhancedDropdown = (0, utils_1.isValidEnhancedDropdown)(link);
    const mainLinkBorderBottom = (0, utils_1.isValidExternalColumn)((_a = link === null || link === void 0 ? void 0 : link.enhancedDropdown) === null || _a === void 0 ? void 0 : _a.externalColumn);
    const enhanced = link.enhancedDropdown || {};
    const { describeColumn = {}, externalColumn = {} } = enhanced;
    const kids = link.kids || [];
    const hasKids = Boolean(kids.length);
    let customMainLinks;
    if (enhanced && enhanced.mainLinksNode) {
        customMainLinks = react_1.default.cloneElement(react_1.default.createElement(react_1.default.Fragment, null, enhanced.mainLinksNode), { links: kids, locale });
    }
    let customExternalColumn;
    if (externalColumn && externalColumn.externalColumnNode) {
        customExternalColumn = react_1.default.cloneElement(react_1.default.createElement(react_1.default.Fragment, null, externalColumn.externalColumnNode), Object.assign(Object.assign({}, externalColumn), { locale }));
    }
    const validCustomNodes = Boolean(customMainLinks || customExternalColumn);
    const validInnerMenu = hasKids || validCustomNodes;
    const menuClasses = (0, classnames_1.default)("tray-menu-item", { dropdown: parentMenuOpen && menuOpen });
    return (react_1.default.createElement(Styled, { className: menuClasses, onKeyUp: onKeyUp, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick },
        react_1.default.createElement(TrayItem_1.TrayItem, { isMenuToggle: validInnerMenu, toggleMenu: !menuOpen ? toggleMenu : undefined, role: "menuitem", tabIndex: menuOpen ? -1 : 0, className: menuClasses, onKeyUp: onKeyUp, locale: locale, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick, link: link },
            react_1.default.createElement("div", { className: "tray-item-inner" },
                react_1.default.createElement("span", { className: "tray-item-title" }, link.title),
                validInnerMenu ? react_1.default.createElement(atoms_1.ArrowIcon, null) : ""),
            react_1.default.createElement(TrayItem_1.TrayContent, { className: "mobile-tray-content", menuOpen: menuOpen, topOffset: topOffset },
                react_1.default.createElement(BackTrayItem_1.BackTrayItem, { toggleMenu: toggleMenu, menuOpen: menuOpen }),
                isEnhancedDropdown ? (react_1.default.createElement(enhanced_1.EnhancedDropdownLayout, { menuOpen: menuOpen, thin: true },
                    react_1.default.createElement(enhanced_1.DescribeColumn, Object.assign({}, describeColumn, { locale: locale })),
                    customMainLinks || react_1.default.createElement(enhanced_1.MainLinks, { links: kids, borderBottom: mainLinkBorderBottom, locale: locale }),
                    customExternalColumn || react_1.default.createElement(enhanced_1.ExternalColumn, Object.assign({}, externalColumn, { locale: locale })))) : (react_1.default.createElement(MobileLinks_1.MobileLinks, { menuOpen: menuOpen, links: kids, locale: locale }))))));
};
exports.MobileTrayMenu = MobileTrayMenu;
//# sourceMappingURL=MobileTrayMenu.js.map